import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from "moment";

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const USER_PERMISSIONS = 'auth-user-permissions';
const ROLE_LIST = 'role_list';
const TOURNAMENT_DATA = 'tournamentData';
const CATEGORY_LIST = 'parentcategory_list';
const REFERALCODE = 'referalcode';
const OPENCART_API_TOKEN = 'opencartApi_token';
const ACTIVE_MODULE = 'activeModule';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor(private router: Router) {
    window.addEventListener('storage', this.handleStorageEvent, false);

    this.requestSyncSessionStorage();
  }
  handleStorageEvent = (event: StorageEvent): void => {
    if (event.key === 'requestSyncSessionStorage') {
      //console.log('handleStorageEvent - requestSyncSessionStorage', event);
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      localStorage.removeItem('sessionStorage');
    } else if (event.key === 'sessionStorage') {
      //console.log('handleStorageEvent - sessionStorage', event);
      const sessionStorage = JSON.parse(event.newValue || '{}');
      for (const key in sessionStorage) {
        window.localStorage.setItem(key, sessionStorage[key]);
      }
    }
  };

  requestSyncSessionStorage(): void {
    //console.log('requestSyncSessionStorage - sessionStorage', sessionStorage);
    if (!sessionStorage.length) {
      const current = new Date().toLocaleTimeString();
      //console.log('requestSyncSessionStorage - request', current);
      localStorage.setItem(
        'requestSyncSessionStorage',
        'request session storage' + current
      );
    }
  }

  public getData(key: string) {
    return localStorage.getItem(key)
  }
  signOut(): void {
    window.localStorage.clear();
  }

  public saveReferalcode(referalcode: string): void {    
    window.localStorage.removeItem(REFERALCODE);
    window.localStorage.setItem(REFERALCODE, referalcode);
  }

  public getReferalcode(): string | null {
    return window.localStorage.getItem(REFERALCODE);
  }



  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public saveOpenCartApiToken(apiToken:string) {
    window.localStorage.removeItem(OPENCART_API_TOKEN);
    window.localStorage.setItem(OPENCART_API_TOKEN, apiToken);
  }

  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  public getOpenCartApiToken(): string | null {
    return window.localStorage.getItem(OPENCART_API_TOKEN);
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public saveTournamentData(data: any): void {
    window.localStorage.removeItem(TOURNAMENT_DATA);
    window.localStorage.setItem(TOURNAMENT_DATA, JSON.stringify(data));
  }
  public getTournamentData(): any {
    const tournamentData = window.localStorage.getItem(TOURNAMENT_DATA);
    if (tournamentData) {
      return JSON.parse(tournamentData);
    }
    return {};
  }
  public removeTournamentData(): any {
    window.localStorage.removeItem(TOURNAMENT_DATA);
  }
  public saveUserPermissions(permission: any): void {
    window.localStorage.setItem(USER_PERMISSIONS, JSON.stringify(permission));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }
  public removeUser(): any {
    window.localStorage.removeItem(USER_KEY);
  }

  public saveRolelist(rolelist): void {
    window.localStorage.removeItem(ROLE_LIST);
    window.localStorage.setItem(ROLE_LIST, JSON.stringify(rolelist));
  }

  public getRolelist(): any {
    const rolelist = window.localStorage.getItem(ROLE_LIST);
    if (rolelist) {
      return JSON.parse(rolelist);
    }
    return {};
  }

  public saveCategorylist(categorylist): void {
    window.localStorage.removeItem(CATEGORY_LIST);
    window.localStorage.setItem(CATEGORY_LIST, JSON.stringify(categorylist));
  }

  public getCategorylist(): any {
    const categorylist = window.localStorage.getItem(CATEGORY_LIST);
    if (categorylist) {
      return JSON.parse(categorylist);
    }
    return {};
  }


  public getUserPermissions(): any {
    const permission = window.localStorage.getItem(USER_PERMISSIONS);
    if (permission) {
      return JSON.parse(permission);
    }
    return {};
  }
  public getClient(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  getAuthStatus(data: any) {
    const token = this.getToken() // get token from local storage
    const expiresAt = moment().add(data.expires_in, 'second');
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('currentUserData', JSON.stringify(data.userdata));
    localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()));
  }

  public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  public isLoggedOut() {
    localStorage.clear();
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.removeItem(USER_PERMISSIONS);
    window.localStorage.removeItem(ROLE_LIST);
    window.localStorage.removeItem(CATEGORY_LIST);

    //this.router.navigateByUrl("/manage/login" ); //go to login if not authenticated
    return !this.isLoggedIn();
  }


  getExpiration() {
    const expiration = localStorage.getItem("expires_at");
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }

  setActiveModule(module) {
    window.localStorage.setItem(ACTIVE_MODULE, JSON.stringify(module));
  }

  getActiveModule() {
    const activeModule = window.localStorage.getItem(ACTIVE_MODULE);
    if (activeModule) {
      return JSON.parse(activeModule);
    }
    return {};
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.handleStorageEvent, false);
  }
}